import ReactMarkdown from 'react-markdown'
// @ts-ignore
import policy from './policy.md'
import GenericLayout from 'components/GenericLayout'

function PrivacyPolicy() {
  return (
    <GenericLayout>
      <div className="prose pb-20 max-w-full">
        <ReactMarkdown>{policy}</ReactMarkdown>
      </div>
    </GenericLayout>
  )
}

export default PrivacyPolicy
